const tg = window.Telegram.WebApp;

const useTelegram = () => {
  tg.setBackgroundColor("#15171a");

  return {
    user: tg.initDataUnsafe?.user,
    tg,
  };
};

export default useTelegram;
